import { render, staticRenderFns } from "./change-type.vue?vue&type=template&id=0c5b9a4f&"
import script from "./change-type.vue?vue&type=script&lang=js&"
export * from "./change-type.vue?vue&type=script&lang=js&"
import style0 from "./change-type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports